export default {
  showMore: {
    id: 'bo_seller_customer_reviews_filters_see_more',
    defaultMessage: 'See more filters',
  },
  showLess: {
    id: 'bo_seller_customer_reviews_filters_see_less',
    defaultMessage: 'See less filters  ',
  },
}
